<template>
  <DialogTemplate class="dialog">
    <template #header>
      <h3 class="title">Changer de profil</h3>
    </template>
    <ul class="avatar-section">
      <li key="add">
        <DialogProfileItemAdd :disabled="!profile.isAllowedToAddFamilyMember" />
      </li>
      <li v-for="familyMember in members" :key="familyMember.memberId">
        <DialogProfileItemAvatar
          :member="familyMember"
          :add-details="false"
          :is-current-member-clickabled="false"
          @select="handleClickSwitch"
        />
      </li>
    </ul>
    <nuxt-link
      class="manage-account"
      to="/mon-compte"
      :class="{ active: isActive }"
      @click="dialog.close"
    >
      <icon name="edit" />
      <span class="infos">{{ $t('settings.manageMyAccount') }}</span>
    </nuxt-link>
  </DialogTemplate>
</template>
<script lang="ts" setup>
import DialogProfileNotASubscriber from '~/components/dialog/profile/DialogProfileNotASubscriber.vue';
import DialogProfilNotAllowedToSwitch from '~/components/dialog/profile/DialogProfilNotAllowedToSwitch.vue';

const profile = useProfileStore();

const context = useContextStore();

const dialog = useDialogStore();

const { avatarUrl, name, id } = useFamilyShadowMember();

const { t: $t } = useI18n();

const familySwitchMember = useFamilySwitchMember();

const members = computed<FamilyMember[]>(() => {
  if (profile.familyMembers.length === 0) {
    return [
      {
        avatarUrl: avatarUrl.value,
        name: name.value,
        memberId: id.value,
        coaching: null,
      },
    ];
  }
  return [...profile.familyMembers].reverse();
});

const route = useRoute();

const isActive = computed(() => {
  return route.path === `/mon-compte`;
});

const handleClickSwitch = (member: FamilyMember) => {
  if (member.memberId === context.memberId) return;
  if (!profile.isASubscriber) {
    dialog.close();
    dialog.open(DialogProfileNotASubscriber, {
      level: DialogLevel.Info,
      member,
    });
  } else if (!familySwitchMember.canSwitchToMember(member)) {
    dialog.close();
    dialog.open(DialogProfilNotAllowedToSwitch, {
      level: DialogLevel.Info,
      member,
    });
  } else {
    familySwitchMember.switchToMember(member);
  }
};
</script>
<style lang="scss" scoped>
.dialog {
  width: 100%;
  @include above('l') {
    max-width: var(--aside_width);
  }
  .title {
    width: 100%;
    text-align-last: center;
  }
  .avatar-section {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(9rem, 1fr));
    @include above('l') {
      grid-template-columns: repeat(auto-fill, minmax(6rem, 1fr));
    }

    width: 100%;
    direction: rtl;
    gap: var(--gap_m);
  }
  .manage-account {
    display: flex;
    align-items: center;
    margin-top: var(--gap_l);
    gap: var(--gap_xs);

    &.active,
    &:hover,
    &:focus {
      transition: color 250ms $ease-out-quad;
      color: var(--color_secondary);
    }
  }
}
</style>
